/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { useLayout } from '../../core'
import { HeaderToolbar } from './HeaderToolbar'
import { Topbar } from './Topbar'
import { HeaderUserMenu } from '../../../partials/layout/header-menus/HeaderUserMenu'
import logo from '../../../../_metronic/assets/logo/logo.png'
import { useMobile } from '../../../../app/hooks/useMobile';
import { useAuth } from '../../../../app/modules/auth';
import './style.scss'

export function HeaderWrapper() {
  const { config, classes, attributes } = useLayout()
  const { aside } = config
  const isMobile = useMobile()
  const { currentUser } = useAuth()

  return (
    <div
      style={{backgroundColor: 'white'}}
      id='kt_header'
      className={clsx('header topHeader', classes.header.join(' '), 'align-items-stretch', 'justify-content-between')}
      {...attributes.headerMenu}
    >
      <div className='header-brand' style={{backgroundColor: 'white'}}>
        <Link to='/'>
          <img
            alt='Logo'
            src={logo}
            className='mr-5 d-block logo_img'
          />
        </Link>
        
        {/* Mobile Profile Section - User info inline with logo */}
        {isMobile && (
          <div className='d-flex align-items-center mr-3' style={{position: 'relative'}}>
            <div
              className='cursor-pointer symbol'
              data-kt-menu-trigger='click'
              data-kt-menu-attach='parent'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='bottom'
            >
              <span className='kp-user-trigger'>
                <span className='kp-user-trigger-avatar'>
                  {(currentUser?.firstName || currentUser?.email || 'AD').slice(0, 2).toUpperCase()}
                </span>
                <span className='kp-user-trigger-label'>
                  {currentUser?.firstName || 'Admin'}
                </span>
                <i className='bi bi-chevron-down kp-user-trigger-caret'></i>
              </span>
            </div>
            <HeaderUserMenu />
          </div>
        )}
        
        {/* end::Logo */}

        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon aside-minimize kp-aside-toggle'
            role='button'
            tabIndex={0}
            aria-label='Toggle sidebar'
            title='Toggle sidebar'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
          >
            <i className='bi bi-chevron-bar-left minimize-default'></i>
            <i className='bi bi-chevron-bar-right minimize-active'></i>
          </div>
        )}

        {/* begin::Aside toggle */}
        {!isMobile && (
          <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
            <div
              className='btn btn-icon btn-active-color-primary w-30px h-30px'
              id='kt_aside_mobile_toggle'
            >
              <i className="bi bi-list fs-1"></i>
            </div>
          </div>
        )}
        {/* end::Aside toggle */}
      </div>
      {/* end::Brand */}
      {/* <HeaderToolbar /> */}
      {!isMobile && (<Topbar />)}
    </div>
  )
}
